import React, { useState } from 'react';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: "Rajesh Kumar",
      company: "Tech Solutions Inc.",
      content: "Netbernet transformed our online presence with their exceptional web development and SEO services. Our traffic increased by 200% within just 3 months!",
      avatar: "https://tse1.mm.bing.net/th/id/OIP.T7tBLO8sHE4HUnjFK5Q3HAHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      name: "Priya Sharma",
      company: "Global Enterprises",
      content: "Their cloud migration service was seamless. We experienced zero downtime and our operational efficiency improved dramatically. Highly recommended!",
      avatar: "https://media.istockphoto.com/id/1133765698/vector/person-gray-photo-placeholder-woman.jpg?s=612x612&w=0&k=20&c=W2lEcOJdC2xGJLOZKZjBSu2fq3pCJ1NQGjzn3INnmXg="
    },
    {
      name: "Vikram Singh",
      company: "StartUp Ventures",
      content: "The mobile app developed by Netbernet exceeded our expectations. Their team was professional, responsive, and delivered ahead of schedule.",
      avatar: "https://tse1.mm.bing.net/th/id/OIP.T7tBLO8sHE4HUnjFK5Q3HAHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-16 px-6 bg-netbernet-white">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-600">Don't just take our word for it - hear from our satisfied clients</p>
        </div>
        
        <div className="max-w-4xl mx-auto bg-netbernet-blue rounded-xl p-8 md:p-12 text-netbernet-white relative">
          <FaQuoteLeft className="text-4xl text-netbernet-white opacity-20 absolute top-6 left-6" />
          
          <div className="text-center relative z-10">
            <p className="text-xl italic mb-8">
              "{testimonials[currentTestimonial].content}"
            </p>
            
            <div className="flex items-center justify-center">
              <img 
                src={testimonials[currentTestimonial].avatar} 
                alt={testimonials[currentTestimonial].name}
                className="w-16 h-16 rounded-full mr-4 border-4 border-netbernet-white"
              />
              <div>
                <div className="font-bold text-lg">{testimonials[currentTestimonial].name}</div>
                <div className="text-blue-100">{testimonials[currentTestimonial].company}</div>
              </div>
            </div>
          </div>
          
          <div className="flex justify-center mt-8 space-x-4">
            <button 
              onClick={prevTestimonial}
              className="p-2 rounded-full bg-netbernet-white bg-opacity-20 hover:bg-opacity-30 transition-colors"
            >
              <FaChevronLeft className="text-netbernet-white" />
            </button>
            <button 
              onClick={nextTestimonial}
              className="p-2 rounded-full bg-netbernet-white bg-opacity-20 hover:bg-opacity-30 transition-colors"
            >
              <FaChevronRight className="text-netbernet-white" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;